import React, { Component } from "react";
import Header from "../../../Header/header";
import { accessControl } from "../../../../permission/permission";
class SubcategoryForm extends Component {
  constructor() {
    super();
    accessControl([1, 4]);
  }
  render() {
    return (
      <>
        <Header isFaculty={false} />
        <form onSubmit={this.props.handleSubmit}>
          <div className="card-body" style={{ textAlign: "left" }}>
            <div
              className="scroll-y me-n7 pe-7"
              id="kt_modal_new_address_scroll text-left"
              data-kt-scroll="true"
              data-kt-scroll-activate="{default: false, lg: true}"
              data-kt-scroll-max-height="auto"
              data-kt-scroll-dependencies="#kt_modal_new_address_header"
              data-kt-scroll-wrappers="#kt_modal_new_address_scroll"
              data-kt-scroll-offset="300px"
            >
              <div className="row mb-5">
                <div className="col-md-4 fv-row">
                  <label className="required fs-5 fw-bold mb-2">Category</label>
                  <select
                    className="form-control form-control-solid"
                    name="categoryName"
                    id="categoryName"
                    onChange={this.props.onEdit}
                    value={this.props.data.categoryName}
                  >
                    <option value="">Select category</option>
                    {this.props.categoryList.map((category, index) => {
                      return (
                        <option key={index} data={category.EntryID} value={category.EntryID}>
                          {category.CategoryName}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-4 fv-row">
                  <label className="required fs-5 fw-bold mb-2">Sub Category</label>
                  <input
                    type="text"
                    className="form-control form-control-solid btn-block  mb-5"
                    name="subcategoryName"
                    id="subcategoryName"
                    onChange={this.props.onEdit}
                    value={this.props.data.subcategoryName}
                    placeholder="Sub Category"
                  />
                </div>
                <div className="col-md-4">
                  <button
                    type="submit"
                    id="kt_modal_new_address_submit"
                    data-kt-indicator={this.props.isLoading}
                    className="btn btn-primary w-25 offset-4 mb-9 mt-9"
                  >
                    {this.props.isLoading ? <span className="indicator-label">Please wait...</span> : <span className="indicator-label">Submit</span>}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }
}

export default SubcategoryForm;
